module.exports = __webpack_public_path__ + "img/34_35.da249e9e.png";